import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import './Modal.css';

const Modal = (props) => {
  return (
    <Dialog
      onClose={props.handleClose}
      open={props.open}
      maxWidth={props?.maxWidth || "md"}
      style={{ height: '600px' }}
      fullWidth={props.fullWidth || false}
      className={props.className || "Dailog_cls"}
      fullScreen={props.fullScreen || false}
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        {props.title}
      </DialogTitle>
      <IconButton
        aria-label="close"
        onClick={props.handleClose}
        sx={{
          position: 'absolute',
          right: 8,
          top: 8,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <DialogContent dividers className={`dailogContent ${props.contentClassName}`}>
        {props.content}
      </DialogContent>
      <DialogActions>
        {props.action}
      </DialogActions>
    </Dialog>
  )
}

export default Modal